import { create } from 'zustand';

import { MigrationState, MigrationStatus } from '@/types/migration';

const LOCKED_STATES: ReadonlySet<MigrationState> = new Set<MigrationState>([
  'in_progress',
  'completed',
  'unknown',
]);

interface MigrationStore {
  status: MigrationStatus | null;
  orderGateLockedAt: number | null;
  isAccountEmpty: boolean;

  setStatus: (status: MigrationStatus | null) => void;

  setIsAccountEmpty: (isAccountEmpty: boolean) => void;

  lockOrderGate: () => void;

  reset: () => void;
}

export const isMigrationLockedState = (state: MigrationState) =>
  LOCKED_STATES.has(state);

export const useMigrationStore = create<MigrationStore>()((set, get) => ({
  status: null,
  orderGateLockedAt: null,
  isAccountEmpty: false,

  setStatus: (status) => set({ status }),

  setIsAccountEmpty: (isAccountEmpty) => set({ isAccountEmpty }),

  lockOrderGate: () => {
    if (get().orderGateLockedAt !== null) return;
    set({ orderGateLockedAt: Date.now() });
  },

  reset: () =>
    set({ status: null, orderGateLockedAt: null, isAccountEmpty: false }),
}));

export const selectIsMigrationCompleted = (
  state: Pick<MigrationStore, 'status'>,
): boolean =>
  state.status !== null &&
  state.status.started &&
  state.status.state === 'completed';

export const getIsMigrationCompleted = (): boolean =>
  selectIsMigrationCompleted(useMigrationStore.getState());

export const selectIsMigrationTradingBlocked = (
  state: Pick<
    MigrationStore,
    'status' | 'orderGateLockedAt' | 'isAccountEmpty'
  >,
): boolean => {
  if (state.orderGateLockedAt !== null) return true;
  const { status } = state;
  if (status === null) return false;
  if (!status.started) return state.isAccountEmpty;
  return isMigrationLockedState(status.state);
};
